<template>
    <div class="components-introduce-box">
        <div class="box-title">
            <img :src="props.data.icon" alt="" />
            <div class="text">{{props.data.title }}</div> 
        </div>
        <div class="box-content" v-html="props.data.desc"></div>
    </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
</script>

<style lang="scss" scoped>
.components-introduce-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 76px;
    .box-title{
        display: flex;
        align-items: center;
        img{
            width: 30px;
            height: 30px;
        }
        .text{
            color: rgb(38, 38, 38);
            font-family: 阿里巴巴普惠体 2.0;
            font-size: 28px;
            font-weight: 700;
            line-height: 39px;
            letter-spacing: 0px;
            margin-left: 12px;
        }
    }
    .box-content{
        color: rgb(38, 38, 38);
        font-family: 阿里巴巴普惠体 2.0;
        font-size: 16px;
        font-weight: 300;
        line-height: 32px;
        letter-spacing: 0px;
        margin-top: 32px;
        text-align: justify;
        margin-left: 2px;
    }
}
</style>
